import { Post } from "./post";
import { EventEmitter } from "@angular/core";





export class TimelineService {


    show = false;
    component = new EventEmitter<any>();
    order = null;
    update = new EventEmitter<any>()

    select1 = 'Share';
    select2 = 'Public';
    selected = '';
    arr: any = [];
    comment = '';
    tag: string = 'select';
    showTag = false;
    post: string = '';
    screenSize = true;
    comments: any = [];
    posts: any = [];
    shareType = '';
    ref = '';
    sendFrom = '';
    selectedFile: File = null;
    imgUrl = [];


    constructor() { }

    ngOnInit() {
    }

    // for back to the previous page
    goBack() {
        window.history.back()
    }



    onSelect1(s: string) {
        this.select1 = s;
        this.selected = s;

    }
    onClick() {
        this.screenSize = !this.screenSize;
    }
    onSelect2(s: string) {
        this.select2 = s;
        if (this.select2 !== 'Public') {
            this.showTag = true;

        }
        if (this.select2 == 'Public') {
            this.showTag = false;

        }

    }

    onDelete(index) {
        this.arr.splice(index, 1);
    }

    onSend() {
        const d = new Date();
        //date & time format
        const date = [d.getDate(),
        d.getMonth() + 1,
        d.getFullYear()].join('/') + ' ' +
            [d.getHours(),
            d.getMinutes(),
            d.getSeconds()].join(':');
        if (this.comment !== '') {
            this.comments.push({ comment: this.comment, date: date });
        }
        this.comment = '';
    }
    onTag(tag: string) {
        this.tag = tag;
        this.arr.push('' + tag + '');

    }

    onPost() {
        const tag = this.arr;
        const d = new Date();
        const date = [d.getDate(),
        d.getMonth() + 1,
        d.getFullYear()].join('/') + ' ' +
            [d.getHours(),
            d.getMinutes(),
            d.getSeconds()].join(':');
        if (this.post !== '') {
            this.posts.push({ post: this.post, date: date, tag: tag, share: this.select1, order: this.shareType, img: this.imgUrl });

        }

        this.post = '';
        this.arr = [];
        this.imgUrl = [];
    }






    // Selected File
    onFileChanged(file) {

        if (file.target.files && file.target.files[0]) {
            var filesAmount = file.target.files.length;
            for (let i = 0; i < filesAmount; i++) {
                var reader = new FileReader();

                reader.onload = (event: any) => {
                    this.imgUrl.push(event.target.result);
                }

                reader.readAsDataURL(this.selectedFile = file.target.files[i]);
            }
        }

    }
}